import React, { Component } from "react";
import axios from "axios";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import { Card, CardHeader } from "reactstrap";
import { EditOutlined } from '@ant-design/icons';
import generateFilter from "../../utils/generateFilter";
import DeleteMaterialModal from "../HomeVisits/DeleteMaterialModal";
import MaterialDrawer from "./components/MaterialModalDrawer";
import {
    Table,
    Button,
    Tooltip,
    Empty,
    message
} from "antd";
class materials extends Component {
    constructor(props) {
        super(props);
        this.state = {
            materials: [],
            isLoadingTable: false,
            showDeleteModal: false,
            materialToDelete: null,
            isNewMaterial: false,
            showDrawerModal: false,
            material: null
        };
        this.loadMaterialsCall = this.loadMaterialsCall.bind(this);
        this.handleOpenDeleteModal = this.handleOpenDeleteModal.bind(this);
        this.handleDeleteMaterial = this.handleDeleteMaterial.bind(this);
        this.handleOpenDrawerModal = this.handleOpenDrawerModal.bind(this);
        this.handleOpenNewDrawerModal = this.handleOpenNewDrawerModal.bind(this);
        this.handleOpenEditModal = this.handleOpenEditModal.bind(this);
    }
    componentDidMount() {
        this.loadMaterialsCall();
    }
    loadMaterialsCall = async () => {
        this.setState({ isLoadingTable: true })
        try {
            const materialsCall = await axios.get('https://backoffice.nadu.xyz/api/material-types');
            if (materialsCall && materialsCall.data) {
                this.setState({ materials: materialsCall.data })
            } else {
                message.error('Error al obtener los materiales');
            }
        } catch (error) {
            message.error('Error al obtener los materiales');
            console.error('Error al obtener contenido:', error);
        }
        this.setState({ isLoadingTable: false })
    };
    handleOpenDeleteModal = (boolean) => {
        this.setState({ showDeleteModal: boolean });
    }
    handleDeleteMaterial = (record) => {
        this.setState({ materialToDelete: record });
        this.handleOpenDeleteModal(true);
    }
    handleOpenDrawerModal = (boolean) => {
        this.setState({ showDrawerModal: boolean });
    }
    handleOpenNewDrawerModal = (boolean) => {
        this.setState({ isNewMaterial: true });
        this.setState({ material: null }),
            this.setState({ showDrawerModal: boolean });;
    }
    handleOpenEditModal = (record) => {
        this.setState({ material: record });
        this.setState({ isNewMaterial: false });
        this.setState({ showDrawerModal: true });
    }
    render() {
        let columnsMaterials = [
            {
                title: "Nombre",
                dataIndex: "name",
                key: "name",
                ...generateFilter(
                    "nombre",
                    ["name"],
                    (value, record) =>
                        record.name &&
                        record.name.toLowerCase().includes(value.toLowerCase())
                ),
            },
            {
                title: "Tipo de valor",
                dataIndex: "type",
                key: "type",
                filters: [
                    {
                        text: "Selección única",
                        value: "single",
                    },
                    {
                        text: "Selección múltiple",
                        value: "multiple",
                    },
                    {
                        text: "Verdadero/Falso",
                        value: "boolean",
                    },
                    {
                        text: "Texto",
                        value: "text",
                    },
                    {
                        text: "Número",
                        value: "number",
                    },
                ],
                onFilter: (value, record) => {
                    return record.type === value;
                },
                render: (type, record) => {
                    return (
                        record.type === "single" ? (
                            "Único"
                        ) : record.type === "multiple" ? (
                            "Multiple"
                        ) : record.type === "boolean" ? (
                            "Verdadero/Falso"
                        ) : record.type === "text" ? (
                            "Texto"
                        ) : record.type === "number" ? (
                            "Numérico"
                        ) : (
                            "Sin tipo"
                        )
                    )
                },
                align: "center",
            },
            {
                title: "Tipos de cita",
                key: "appointment_types",
                filters: [
                    { text: ".glass", value: "359" },
                    { text: "Configuración", value: "245" },
                    { text: "Incidencia", value: "244" },
                    { text: "Instalación DECOs/StickTV/Fijo", value: "387" },
                    { text: "Instalación Fibra", value: "256" },
                    { text: "Instalación WiFi", value: "243" },
                    { text: "Mantenimiento", value: "383" },
                    { text: "Servicio extra", value: "246" },
                    { text: "Trabajos propios", value: "386" }
                ],
                onFilter: (value, record) => {
                    return record.appointment_types.some(appointment_type => appointment_type.id_nadunet === value);
                },
                render: (type, record) => {
                    return (
                        < Tooltip title={
                            record.appointment_types.map((child, index) =>
                                child ? <div key={index}>{child.name}</div> : null
                            )}>
                            {record.appointment_types.length + (record.appointment_types.length > 1 ? " tipos de cita" : " tipo de cita")}
                        </Tooltip>
                    )
                },
                align: "center",
            },
            {
                title: "Opciones de selección",
                key: "material_options",
                filters: [
                    { text: ".glass", value: "359" },
                    { text: "Configuración", value: "245" },
                    { text: "Incidencia", value: "244" },
                    { text: "Instalación DECOs/StickTV/Fijo", value: "387" },
                    { text: "Instalación Fibra", value: "256" },
                    { text: "Instalación WiFi", value: "243" },
                    { text: "Mantenimiento", value: "383" },
                    { text: "Servicio extra", value: "246" },
                    { text: "Trabajos propios", value: "386" }
                ],
                onFilter: (value, record) => {
                    return record.material_options.some(option => option.appointment_type.id_nadunet === value);
                },
                render: (type, record) => {
                    return (
                        < Tooltip title={
                            record.material_options.map((child, index) =>
                                child ? <div key={index}>{child.name}</div> : null
                            )}>
                            {record.material_options.length > 0 ? record.material_options.length + (record.material_options.length > 1 ? " opciones de selección" : " opción de selección") : null}
                        </Tooltip>
                    )
                },
                align: "center",
            },
            {
                title: "Tipo de material",
                key: "material_type",
                filters: [
                    {
                        text: "Extra",
                        value: "extra",
                    },
                    {
                        text: "Obligatorio",
                        value: "obligatorio",
                    },
                    {
                        text: "Opcional",
                        value: "opcional",
                    },
                ],
                onFilter: (value, record) => {
                    if (value === "extra") {
                        return record.isGlobal;
                    }
                    if (value === "obligatorio") {
                        return !record.isGlobal && record.mandatory;
                    }
                    if (value === "opcional") {
                        return !record.isGlobal && !record.mandatory;
                    }
                    return false;
                },
                render: (type, record) => {
                    return record.isGlobal ? "Extra" : record.mandatory ? "Obligatorio" : "Opcional";
                },
                align: "center",
            },
            {
                title: "Acciones",
                key: "Actions",
                align: "center",
                render: (text, record) => (
                    <div style={{ display: "flex", flexDirection: "row", gap: 4, justifyContent: "center" }}>
                        <Tooltip placement="left" title="Editar material">
                            <Button type="primary" disabled={false} onClick={() => this.handleOpenEditModal(record)}><EditOutlined /></Button>
                        </Tooltip>
                        <Tooltip title="Eliminar material">
                            <Button type="primary" danger onClick={() => this.handleDeleteMaterial(record)}>
                                <svg width="14px" height="14px" viewBox="0 0 24 24" fill="none">
                                    <g id="Interface / Trash_Empty">
                                        <path id="Vector" d="M6 6V17.8C6 18.9201 6 19.4798 6.21799 19.9076C6.40973 20.2839 6.71547 20.5905 7.0918 20.7822C7.5192 21 8.07899 21 9.19691 21H14.8031C15.921 21 16.48 21 16.9074 20.7822C17.2837 20.5905 17.5905 20.2839 17.7822 19.9076C18 19.4802 18 18.921 18 17.8031V6M6 6H8M6 6H4M8 6H16M8 6C8 5.06812 8 4.60241 8.15224 4.23486C8.35523 3.74481 8.74432 3.35523 9.23438 3.15224C9.60192 3 10.0681 3 11 3H13C13.9319 3 14.3978 3 14.7654 3.15224C15.2554 3.35523 15.6447 3.74481 15.8477 4.23486C15.9999 4.6024 16 5.06812 16 6M16 6H18M18 6H20" stroke={"#FFFFFF"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                </svg>
                            </Button>
                        </Tooltip>
                    </div>
                ),
            },
        ]
        return (
            <div>
                {this.state.showDeleteModal &&
                    <DeleteMaterialModal
                        materialToDelete={this.state.materialToDelete}
                        reloadCall={this.loadMaterialsCall}
                        handleOpenModal={this.handleOpenDeleteModal}
                    />
                }
                <MaterialDrawer
                    isNewMaterial={this.state.isNewMaterial}
                    handleOpenDrawerModal={this.handleOpenDrawerModal}
                    loadMaterialsCall={this.loadMaterialsCall}
                    showDrawerModal={this.state.showDrawerModal}
                    material={this.state.material}
                />
                <PanelHeader size="sm" />
                <div className="content">
                    <Card>
                        <CardHeader
                            style={{ display: "flex", justifyContent: "space-between" }}
                        >
                            <h5>Materiales de citas</h5>
                            <Button
                                type="primary"
                                onClick={() => this.handleOpenNewDrawerModal(true)}
                            >
                                Añadir nuevo material
                            </Button>
                        </CardHeader>
                        <div style={{ padding: "6px" }}>
                            <Table
                                columns={columnsMaterials}
                                dataSource={this.state.materials}
                                showSorterTooltip={false}
                                loading={this.state.isLoadingTable}
                                style={{ width: "100%" }}
                                scroll={{ x: 576 }}
                                rowKey="id"
                                locale={{
                                    emptyText: (
                                        <Empty description={"No hay materiales"} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                    )
                                }}
                            />
                        </div>

                    </Card>
                </div>
            </div>
        );
    }
}

export default materials;



// WEBPACK FOOTER //
// ./src/views/Configurator/materials.jsx